"use strict";

import $ from 'jquery';
import loadJQueryUi from '../load-jquery-ui';
import {dateToISOString, ISOStringToDate, localDateToUTCDate, UTCDateToLocalDate} from "../date-utils";
import {getPrefixedDataSet} from "../data-set-utils";

function addKeyboardSupport($datepicker, $altField) {
    let newDate = localDateToUTCDate($datepicker.datepicker('getDate'));

    $datepicker.on('keydown', function (evt) {
        if(newDate == null) {
            $datepicker.datepicker('setDate', new Date());
            newDate = $datepicker.datepicker('getDate');
        }

        switch (evt.key) {
            case 'ArrowLeft':
                newDate.setDate(newDate.getDate() - 1);
                evt.preventDefault();
                evt.stopImmediatePropagation();
                break;
            case 'ArrowUp':
                newDate.setDate(newDate.getDate() - 7);
                evt.preventDefault();
                evt.stopImmediatePropagation();
                break;
            case 'ArrowRight':
                newDate.setDate(newDate.getDate() + 1);
                evt.preventDefault();
                evt.stopImmediatePropagation();
                break;
            case 'ArrowDown':
                newDate.setDate(newDate.getDate() + 7);
                evt.preventDefault();
                evt.stopImmediatePropagation();
                break;
            case 'PageUp':
                newDate.setDate(newDate.getDate() - 30);
                evt.preventDefault();
                evt.stopImmediatePropagation();
                break;
            case 'PageDown':
                newDate.setDate(newDate.getDate() + 30);
                evt.preventDefault();
                evt.stopImmediatePropagation();
                break;
            case 'Enter':
                newDate.setDate(newDate.getDate());
                $datepicker.datepicker('setDate', newDate);
                $altField.val(dateToISOString(localDateToUTCDate(newDate))).trigger('change');
                $datepicker.datepicker('hide');

                evt.preventDefault();
                evt.stopImmediatePropagation();
                break;
        }

        if (newDate.getTime() !== $datepicker.datepicker('getDate').getTime()) {
            $datepicker.datepicker('setDate', newDate);
        }
    });
}

// returns UTC Date
export function getDate($datepicker) {
    return ISOStringToDate($datepicker.find('.js-datepicker__alt-field').val());
}

// date: UTC DATE
export function setDate($datepicker, date) {
    loadJQueryUi().then(function () {
        $datepicker.find('.js-datepicker__alt-field').val(dateToISOString(date));
        $datepicker.find('.js-datepicker__input').datepicker('setDate', UTCDateToLocalDate(date));
    });

}

// date: UTC DATE
export function setMinDate($datepicker, date) {
    loadJQueryUi().then(function () {
        if ($datepicker.find('.js-datepicker__input').datepicker('getDate').getTime() < date.getTime()) {
            $datepicker.find('.js-datepicker__alt-field').val(dateToISOString(date));
            $datepicker.find('.js-datepicker__input').datepicker('setDate', UTCDateToLocalDate(date));
        }

        $datepicker.find('.js-datepicker__input')
            .datepicker('option', 'minDate', UTCDateToLocalDate(date));
    });
}

// date: UTC DATE
export function setMaxDate($datepicker, date) {
    loadJQueryUi().then(function () {
        if ($datepicker.find('.js-datepicker__input').datepicker('getDate').getTime() > date.getTime()) {
            $datepicker.find('.js-datepicker__alt-field').val(dateToISOString(date));
            $datepicker.find('.js-datepicker__input').datepicker('setDate', UTCDateToLocalDate(date));
        }

        $datepicker.find('.js-datepicker__input')
            .datepicker('option', 'maxDate', UTCDateToLocalDate(date));
    });
}

export function createInitInScope(selectors, defaultOptions) {
    return function ($scope) {
        let $datepickerContainers = $scope.find(selectors.base);
        loadJQueryUi().then(function () {
            $datepickerContainers.each(function () {
                let $container = $(this);
                let $datepicker = $container.find(selectors.input);
                let $altField = $container.find(selectors.altField);

                let options = {
                    numberOfMonths: 1,
                    minDate: UTCDateToLocalDate(new Date()),
                    nextText: '',
                    prevText: '',
                    firstDay: 1,
                    showAnim: 'show', // other animations (like fadeIn) do not work with jquery.slim
                    onSelect: function(dateString, inst) {
                        let selectedDate = new Date(Date.UTC(inst.selectedYear, inst.selectedMonth, inst.selectedDay));
                        $altField.val(dateToISOString(selectedDate)).trigger('change');
                    },
                    ...defaultOptions,
                    ...transformDataOptions(getPrefixedDataSet('datepicker', $container))
                };

                addKeyboardSupport($datepicker, $altField);
                $datepicker.datepicker(options);

                if ($altField.val()) {
                    setDate($container, ISOStringToDate($altField.val()));
                }
            });
        });
    }
}

export const initInScope = createInitInScope({
    base: '.js-datepicker',
    input: '.js-datepicker__input',
    altField: '.js-datepicker__alt-field'
});

function transformDataOptions(options) {
    options = {...options};

    if (options.minDate && typeof options.minDate === 'string') {
        options.minDate = UTCDateToLocalDate(ISOStringToDate(options.minDate));
    }

    if (options.maxDate && typeof options.maxDate === 'string') {
        options.maxDate = UTCDateToLocalDate(ISOStringToDate(options.maxDate));
    }

    return options;
}